module.exports = __webpack_public_path__ + "img/preload-logo-dark.399233be.svg";